module.exports = __webpack_public_path__ + "static/media/past.e77771ab.png";